import { render, staticRenderFns } from "./ListSalesInvoicePage.vue?vue&type=template&id=1236657c"
import script from "./ListSalesInvoicePage.vue?vue&type=script&lang=js"
export * from "./ListSalesInvoicePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports